import {Async, Loaded, Loading } from 'Core/models/Async';

export class UnassignedProductRiderIntModel {
    
    public readonly key = 'UnassignedProductRiderIntModel';
  }

export type ProductRiderIntModel = Async<number[]> | UnassignedProductRiderIntModel;

type MatchProductRiderIntModelOptions<TReturn> = {
    Loading: () => TReturn;
    Loaded: (products: number[]) => TReturn;
    Error: () => TReturn;
    Unassigned: (products: []) => TReturn;
  };

export const isLoading = (products: ProductRiderIntModel): products is Loading<number[]> =>
    products.key === 'Loading';

export const isLoaded = (products: ProductRiderIntModel): products is Loaded<number[]> => products.key === 'Loaded';

export const matchProductRiderIntModel = <TReturn>(options: MatchProductRiderIntModelOptions<TReturn>) => (
    products: ProductRiderIntModel
  ) => {
  
    switch (products.key) {
      case 'UnassignedProductRiderIntModel':
        return options.Unassigned([]);
      case 'Loaded':
        return options.Loaded(products.Data);
      case 'Loading':
        return options.Loading();
      case 'Conflict':
        return options.Error();
      case 'ServerError':
        return options.Error();
      case 'Unauthorized':
        return options.Error();
    }
  };